import IndicatorDot from './indicator-dot'
import streamChatService from '../services/stream-chat'

class ChatIndicatorDot extends IndicatorDot {

  init() {
    streamChatService.on('unreadCount', this.update)
  }

  update(unreadCount) {
    if (this.unreadCount === unreadCount) return
    this.unreadCount = unreadCount
    this.updateStatus(this.getStatus(unreadCount))
  }

  getStatus(count = 0) {
    if (count > 99) return '99+'
    if (count === 0) return false
    return count
  }
}

export default ChatIndicatorDot
